:host {
  display: block;
}

nav.breadcrumbs {
  text-transform: uppercase;
  color: #535353;
  font-size: calc(var(--s1)/ 2.25);
  font-weight: var(--font-weight-bold);
  padding: 0;
  padding: calc(var(--s1)/ 2);
  line-height: 1.42857;
  background-color: var(--color-white);
}

.breadcrumb-links {
  border-bottom: 1px solid var(--color-lighter-gray); 
  padding-bottom: calc(var(--s1)/ 3);
}

a, a:visited, a:link {
  color: var(--color-link-blue);
  text-decoration: none;
  line-height: 1.42857;
}
a:hover{
  text-decoration: underline;
}

a:first-child {

}

.current-page {
  display: inline;
  /*padding-left:  6px;*/
  color: #535353;
}
.current-page:hover {
  text-decoration: none;
}
.current-page::before {
  content: '';
  display: inline-block;
  margin-right: 10px;
  border-top: 1px solid #535353;
  border-right: 1px solid #535353;
  width: 3.88px;
  height: 3.88px;
  transform: rotate(45deg);
  position: relative;
  top: -1px;
}

nav.breadcrumbs ::slotted(a), nav.breadcrumbs ::slotted(a:visited), nav.breadcrumbs ::slotted(a:link) {
  padding: 5px 6px 5px 0px !important;
  line-height: 1.42857 !important;
  color: var(--color-link-blue) !important;
  display: inline !important;
}

nav.breadcrumbs ::slotted(a:first-child) {
  padding-left: 6px !important;
}
nav.breadcrumbs ::slotted(a:last-child) {

}
nav.breadcrumbs ::slotted(a:hover) {
  text-decoration: underline !important;
}
nav.breadcrumbs ::slotted(a)::before {
  content: '' !important;
  display: inline-block !important;
  margin-right: 10px !important;
  border-top: 1px solid #535353 !important;
  border-right: 1px solid #535353 !important;
  width: 4.5px !important;
  height: 4.5px !important;
  transform: rotate(45deg) !important;
  position: relative !important;
  top: -2px !important;
}

